import { render, staticRenderFns } from "./StudentPermissionView.vue?vue&type=template&id=0921733e&scoped=true&"
import script from "./StudentPermissionView.vue?vue&type=script&lang=js&"
export * from "./StudentPermissionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0921733e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
